import type { GenieKnowledgeEntry } from '../../types';

export const myopathy: GenieKnowledgeEntry = {
  id: 'myopathy',
  name: 'Miopatía',
  category: 'miopatico',
  conversation: {
    headline:
      'Proceso primario del músculo. NCS suele ser normal; EMG muestra PAUMs cortos/pequeños con reclutamiento precoz.',
    edxHighlights: [
      'PAUMs de amplitud reducida (<1 mV) y duración corta (<10 ms)',
      'Reclutamiento precoz (early recruitment) con activación completa',
      'Actividad espontánea: fibrilaciones, CRD (miopatía inflamatoria)',
      'NCS motor/sensitivo normal o CMAP levemente reducido',
    ],
    pearls: [
      'NCS normal + EMG miopático = patrón clásico; no omitir aguja.',
      'Debildad proximal + CK elevada orientan a miopatía inflamatoria.',
    ],
    differentials: [
      { name: 'UNM (MG/LEMS)', distinguishingHint: 'fatigabilidad, RNS anormal, PAUMs normales' },
      { name: 'Miotonía', distinguishingHint: 'descargas miotónicas en EMG, relajación lenta' },
    ],
    nextSteps: [
      'Muestrear músculos proximales (deltoides, iliopsoas, cuádriceps)',
      'Solicitar CK, aldolasa; considerar biopsia si inflamatoria',
    ],
  },
  orientationHints: {
    temporalFit: ['subacute', 'chronic'],
    whenToSuspect: 'Debilidad proximal simétrica sin parestesias',
  },
};
